import { render, staticRenderFns } from "./Lectures.vue?vue&type=template&id=d8645b22&scoped=true"
import script from "./Lectures.vue?vue&type=script&lang=js"
export * from "./Lectures.vue?vue&type=script&lang=js"
import style0 from "./Lectures.vue?vue&type=style&index=0&id=d8645b22&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8645b22",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Mobaxe\\Nevo.SimAdmin.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d8645b22')) {
      api.createRecord('d8645b22', component.options)
    } else {
      api.reload('d8645b22', component.options)
    }
    module.hot.accept("./Lectures.vue?vue&type=template&id=d8645b22&scoped=true", function () {
      api.rerender('d8645b22', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Lectures.vue"
export default component.exports